<template>
  <div class="section_nav" :style="width?'width:'+width+'%':''">
    <div class="nav_title">组织架构</div>
    <div class="nav_list">
      <div class="list_item" v-for="(item,i) in list" :key="i">
        <div class="item_img" @click="openItem(1,1,i)" v-if="item.array&&item.array.length>0">
          <el-image src="../../static/images/icon/down.svg" :class="isShowItem(item.id)?'active':''" style="width:10px;height:9px;"></el-image>
        </div>
        <div class="item_desc">
          <div class="desc_inner" :class="chooseing.id==item.id?'inner_active':''" @click="openItem(2,1,i)" :title="item.name">{{item.name}}</div>
          <div class="list_item" v-for="(item2,k) in item.array" :key="k" v-if="isShowItem(item.id)">
            <div class="item_img" @click="openItem(1,2,i,k)" v-if="item2.array&&item2.array.length>0">
              <el-image src="../../static/images/icon/down.svg" :class="isShowItem(item2.id)?'active':''" style="width:10px;height:9px;"></el-image>
            </div>
            <div class="item_desc">
              <div class="desc_inner" :class="chooseing.id==item2.id?'inner_active':''" @click="openItem(2,2,i,k)" :title="item.name+'-'+item2.name">{{item2.name}}</div>
              <div class="list_item" v-for="(item3,z) in item2.array" :key="z" v-if="isShowItem(item2.id)">
                <div class="item_img" @click="openItem(1,3,i,k,z)" v-if="item3.array&&item3.array.length>0">
                  <el-image src="../../static/images/icon/down.svg" :class="isShowItem(item3.id)?'active':''" style="width:10px;height:9px;"></el-image>
                </div>
                <div class="item_desc">
                  <div class="desc_inner" :class="chooseing.id==item3.id?'inner_active':''" @click="openItem(2,3,i,k,z)" :title="item.name+'-'+item2.name+'-'+item3.name">{{item3.name}}</div>
                  <div class="list_item" v-for="(item4,f) in item3.array" :key="f" v-if="isShowItem(item3.id)">
                    <div class="item_img" @click="openItem(1,4,i,k,z,f)" v-if="item4.array&&item4.array.length>0">
                      <el-image src="../../static/images/icon/down.svg" :class="isShowItem(item4.id)?'active':''" style="width:10px;height:9px;"></el-image>
                    </div>
                    <div class="item_desc">
                      <div class="desc_inner" :class="chooseing.id==item4.id?'inner_active':''" @click="openItem(2,4,i,k,z,f)" :title="item.name+'-'+item2.name+'-'+item3.name+'-'+item4.name">{{item4.name}}</div>
                      <div class="list_item" v-for="(item5,g) in item4.array" :key="g" v-if="isShowItem(item4.id)">
                        <div class="item_img" @click="openItem(1,5,i,k,z,f,g)" v-if="item5.array&&item5.array.length>0">
                          <el-image src="../../static/images/icon/down.svg" :class="isShowItem(item5.id)?'active':''" style="width:10px;height:9px;"></el-image>
                        </div>
                        <div class="item_desc">
                          <div class="desc_inner" :class="chooseing.id==item5.id?'inner_active':''" @click="openItem(2,5,i,k,z,f,g)" :title="item.name+'-'+item2.name+'-'+item3.name+'-'+item4.name+'-'+item5.name">{{item5.name}}</div>
                          <div class="list_item" v-for="(item6,p) in item5.array" :key="p" v-if="isShowItem(item5.id)">
                            <div class="item_img" @click="openItem(1,6,i,k,z,f,g,p)" v-if="item6.array&&item6.array.length>0">
                              <el-image src="../../static/images/icon/down.svg" style="width:10px;height:9px;"></el-image>
                            </div>
                            <div class="item_desc">
                              <div class="desc_inner" :class="chooseing.id==item6.id?'inner_active':''" @click="openItem(2,6,i,k,z,f,g,p)" :title="item.name+'-'+item2.name+'-'+item3.name+'-'+item4.name+'-'+item5.name+'-'+item6.name">{{item6.name}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      showList:[],
      chooseing:{}
    }
  },
  props:{
    width:{
      type:Number,
      default:null
    },
    list:{
      type:Array,
      default:[]
    },
    showNotshop:{
      type:Boolean,
      default:false
    },
    isReturn:{//是否还原所选门店
      type:Boolean,
      default:true
    },
    depart_msg:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    isIgnore:{//是否无视非门店判断
      type:Boolean,
      default:false
    }
  },
  watch:{
    list:{
      handler(e){
        if(e){
          if(!this.isReturn){
            if(this.depart_msg.id){
              this.chooseing=this.depart_msg
            }else{
              this.chooseing=e[0];
            }
            this.fixItem();
          }else{
            if(this.isIgnore){//无视is_shop判断
              var choosed=this.$local.get('changeRoster');
              if(choosed.id){
                this.chooseing=choosed;
              }else{
                this.chooseing=e[0];
              }
              this.fixItem();
            }else{
              var choosed=this.$local.get('changeSave');
              if(choosed.id){
                this.chooseing=choosed;
                this.fixItem();
              }else{
                for(var key in e){
                  if(e[key].array&&e[key].is_shop!=1){
                    var item=e[key].array;
                    for(var i in item){
                      if(item[i].array&&item[i].is_shop!=1){
                        var item2=item[i].array;
                        for(var k in item2){
                          if(item2[k].array&&item2[k].is_shop!=1){
                            var item3=item2[k].array;
                            for(var b in item3){
                              if(item3[b].array&&item3[b].is_shop!=1){
                                var item4=item3[b].array;
                                for(var y in item4){
                                  if(item4[y].array&&item4[y].is_shop!=1){
                                    var item5=item4[y].array;
                                    for(var j in item5){
                                      if(item5[j].array&&item5[j].is_shop!=1){
                                        var item6=item5[j].array;
                                        for(var l in item6){
                                          if(item6[l].array&&item6[l].is_shop!=1){
                                            var item7=item6[l].array;
                                            if(item7[0].is_shop==1){
                                              this.chooseing=item7[0];
                                              this.fixItem();
                                              return
                                            }
                                          }else{
                                            this.chooseing=item6[l];
                                            this.fixItem();
                                            return
                                          }
                                        }
                                      }else{
                                        this.chooseing=item5[j];
                                        this.fixItem();
                                        return
                                      }
                                    }
                                  }else{
                                    this.chooseing=item4[y];
                                    this.fixItem();
                                    return
                                  }
                                }
                              }else{
                                this.chooseing=item3[b];
                                this.fixItem();
                                return
                              }
                            }
                          }else{
                            this.chooseing=item2[k];
                            this.fixItem();
                            return
                          }
                        }
                      }else{
                        this.chooseing=item[i];
                        this.fixItem();
                        return
                      }
                    }
                  }else{
                    this.chooseing=e[key];
                    this.fixItem();
                    return
                  }
                }
              }
            }
          }
        }
      },
      immediate:true
    }
  },
  computed:{
    isShowItem(){
      return function(e){
        if(this.showList.indexOf(e)!=-1){
          return true;
        }else{
          return false;
        }
      }
    }
  },
  methods:{
    fixItem(){
      var arr=[];
      for(var i in this.list){//1
        var item=this.list[i];
        if(item.id==this.chooseing.id){
          arr=[item.id];
        }else{
          for(var k in item.array){//2
            var item2=item.array[k];
            if(item2.id==this.chooseing.id){
              arr=[item2.id,item.id]
            }else{
              for(var j in item2.array){//3
                var item3=item2.array[j];
                if(item3.id==this.chooseing.id){
                  arr=[item3.id,item2.id,item.id]
                }else{
                  for(var f in item3.array){//4
                    var item4=item3.array[f];
                    if(item4.id==this.chooseing.id){
                      arr=[item4.id,item3.id,item2.id,item.id]
                    }else{
                      for(var e in item4.array){//5
                        var item5=item4.array[e];
                        if(item5.id==this.chooseing.id){
                          arr=[item5.id,item4.id,item3.id,item2.id,item.id]
                        }else{
                          for(var h in item5.array){//6
                            var item6=item5.array[h];
                            if(item6.id==this.chooseing.id){
                              arr=[item6.id,item5.id,item4.id,item3.id,item2.id,item.id]
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      for(var key in arr){
        if(this.showList.indexOf(arr[key])==-1){
          this.showList.push(arr[key])
        }
      }
    },
    openItem(s,e,i,k,z,f,g,p){
      if(s==1){
        if(e==1){//一层
          var chooseItem=this.list[i].id;
        }else if(e==2){//二层
          var chooseItem=this.list[i].array[k].id;
        }else if(e==3){//三层
          var chooseItem=this.list[i].array[k].array[z].id;
        }else if(e==4){//四层
          var chooseItem=this.list[i].array[k].array[z].array[f].id;
        }else if(e==5){//五层
          var chooseItem=this.list[i].array[k].array[z].array[f].array[g].id;
        }else if(e==6){//六层
          var chooseItem=this.list[i].array[k].array[z].array[f].array[g].array[p].id;
        }
        if(this.showList.indexOf(chooseItem)!=-1){
          var index=this.showList.indexOf(chooseItem);
          this.showList.splice(index,1)
        }else{
          this.showList.push(chooseItem)
        }
      }else if(s==2){
        if(e==1){//一层
          var obj=this.list[i];
          if(obj.is_shop==0){
            this.openItem(1,1,i);
            if(this.showNotshop){
              this.chooseing=this.list[i];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i];
          }
        }else if(e==2){//二层
          var obj=this.list[i].array[k];
          if(obj.is_shop==0){
            this.openItem(1,2,i,k);
            if(this.showNotshop){
              this.chooseing=this.list[i].array[k];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i].array[k];
          }
        }else if(e==3){//三层
          var obj=this.list[i].array[k].array[z];
          if(obj.is_shop==0){
            this.openItem(1,3,i,k,z);
            if(this.showNotshop){
              this.chooseing=this.list[i].array[k].array[z];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i].array[k].array[z];
          }
        }else if(e==4){//四层
          var obj=this.list[i].array[k].array[z].array[f];
          if(obj.is_shop==0){
            this.openItem(1,4,i,k,z,f);
            if(this.showNotshop){
              this.chooseing=this.list[i].array[k].array[z].array[f];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i].array[k].array[z].array[f];
          }
        }else if(e==5){//五层
          var obj=this.list[i].array[k].array[z].array[f].array[g];
          if(obj.is_shop==0){
            this.openItem(1,5,i,k,z,f,g);
            if(this.showNotshop){
              this.chooseing=this.list[i].array[k].array[z].array[f].array[g];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i].array[k].array[z].array[f].array[g];
          }
        }else if(e==6){//六层
          var obj=this.list[i].array[k].array[z].array[f].array[g].array[p];
          if(obj.is_shop==0){
            this.openItem(1,6,i,k,z,f,g,p);
            if(this.showNotshop){
              this.chooseing=this.list[i].array[k].array[z].array[f].array[g].array[p];
            }else{
              return
            }
          }else{
            this.chooseing=this.list[i].array[k].array[z].array[f].array[g].array[p];
          }
        }
        if(this.chooseing.is_shop==1&&!this.isIgnore){
          this.$local.set('changeSave',this.chooseing);
        }
        this.$emit('switchNav',this.chooseing);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::-webkit-scrollbar{display:none;}
  .section_nav{
    width:15%;
    height:84vh;
    display:flex;
    flex-direction:column;
    border-right:1px solid #EDEDED;
    overflow:scroll;
    .nav_title{
      width:100%;
      font-size:16px;
      color:#1A1A1A;
      font-weight:bold;
      white-space:nowrap;
      padding:20px 0;
      box-sizing:border-box;
      text-align:left;
    }
    .nav_list{
      width:100%;
      display:flex;
      flex-direction:column;
      .list_item{
        width:100%;
        display:flex;
        .item_img{
          height:auto;
          display:flex;
          justify-content:center;
          padding:12px 0;
          box-sizing:border-box;
          margin-right:6px;
          cursor:pointer;
          .active{
            transform:rotate(90deg);
          }
        }
        .item_desc{
          width:100%;
          display:flex;
          flex-direction:column;
          .desc_inner{
            width:100%;
            font-size:14px;
            color:rgba(0,0,0,0.85);
            white-space:nowrap;
            padding:5px 6px;
            box-sizing:border-box;
            user-select:none;
            text-align:left;
            transition:0.3s;
          }
          .desc_inner:hover{
            background:#FFE9E3!important;
            color:#FF6B40!important;
          }
          .inner_active{
            background:#FFE9E3!important;
            color:#FF6B40!important;
          }
        }
      }
    }
  }
</style>
